export default __webpack_public_path__ + "static/media/cytocaare-banner-09.f7e2cf5e.jpg";